import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

// The stored account types keep their internal names; people read these labels instead.
const KNOWN_TYPES = ['agency', 'customer', 'candidate'];

/**
 * The account type a person is shown: "Supplier", "Customer" or "Candidate". Any other value is
 * shown capitalised, as it was before the labels existed.
 */
const UserTypeLabel = ({ userType }) => {
  if (KNOWN_TYPES.includes(userType)) {
    return <FormattedMessage id={`UserTypeLabel.${userType}`} />;
  }
  return typeof userType === 'string' && userType ? userType.charAt(0).toUpperCase() + userType.slice(1) : null;
};

export default UserTypeLabel;
